import { sendPostErrorMonitoring } from '../api';

// 导航栏
export function ErrorMonitoringCheckHeaderV2(locale: string) {
    if (typeof window === 'undefined') {
        return null;
    }
    // 新版导航
    if (!document.querySelector('.HeaderV2')) {
        return null;
    }
    // 存在导航
    if (document.querySelector('.HeaderV2-nav-item')) {
        return null;
    }
    sendPostErrorMonitoring(locale, {
        error_type_1: 'content-empty',
        error_type_2: 'HeaderV2',
    });
}

// 配置化
export function ErrorMonitoringCheckEditor(locale: string) {
    if (typeof window === 'undefined') {
        return null;
    }
    const classnameA = `.editor-product:not(.blog-delta-l-side .editor-product)`;
    // 配置化
    if (!document.querySelector(classnameA)) {
        return null;
    }
    const textContentA = (document.querySelector(classnameA)?.textContent || '').trim();
    // 有内容
    if (textContentA) {
        return;
    }
    const error_content_1 = (document.querySelector(classnameA)?.innerHTML || '').trim().slice(0, 250);
    let error_content_2 = '';
    try {
        const dataA1 = document.querySelector('#__NEXT_DATA__')?.textContent || '{}';
        const dataA2 = JSON.parse(dataA1);
        const theTemp1 = dataA2.props.pageProps.tempData1.theTemp;
        const theTemp2 = JSON.stringify(theTemp1);
        error_content_2 = `${theTemp1.length}::${theTemp2}`.slice(0, 250);
    } catch (error) {}
    sendPostErrorMonitoring(locale, {
        error_type_1: 'content-empty',
        error_type_2: 'editor',
        error_content_1,
        error_content_2,
    });
}
